import _debounce from 'lodash/debounce';
import template from './register-data.html';
import ChangesRegisterDataTemplate from './changes-register-data/changes-register-data-dialog.html';

class RegisterDataComponent {
  /** @ngInject */
  constructor($log, $mdDialog, $mdToast, $state, RegisterDataService) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.RegisterDataService = RegisterDataService;
    this.loadPageCallbackWithDebounce = {};
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.registerData) {
      this.registerData = Object.assign([], this.registerData);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  changeFilterName() {
    if (this.loadPageCallbackWithDebounce) {
      this.loadPageCallbackWithDebounce();
    }
  }

  paginatorCallback(page, pageSize) {
    if (angular.isUndefined(page)) {
      page = 1;
    }

    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const query = this.filterName ? this.filterName : null;

    return this.RegisterDataService.getAll({
      offset,
      limit: pageSize,
      query
    }).then(result => {
      this.registerData = result.data.items;
      return {
        results: result.data.items,
        totalResultCount: result.data.total
      };
    });
  }

  viewChanges(value, event) {
    event.stopPropagation();
    const formatedChanges = value.map(item => {
      let typeOfOperation = 'Zmieniono';
      let nameOfField = item.propertyName;

      if (item.operationType === 'added') {
        typeOfOperation = 'Dodano';
      }

      if (item.operationType === 'removed') {
        typeOfOperation = 'Usunięto';
      }

      switch (item.propertyName) {
        case 'first_name':
          nameOfField = 'Imię';
          break;
        case 'last_name':
          nameOfField = 'Nazwisko';
          break;
        case 'phone_number':
          nameOfField = 'Numer telefonu';
          break;
        case 'id_number':
          nameOfField = 'Identyfikator';
          break;
        default:
          nameOfField = 'Nieznane pole';
      }

      return {
        authorFullName: `${item.authorLastName} ${item.authorName}`,
        operationDate: item.operationDate,
        operationType: typeOfOperation,
        propertyName: nameOfField,
        oldValue: item.oldValue,
        newValue: item.newValue,
        authorIp: item.authorIp
      };
    });
    this.$mdDialog.show({
      bindToController: true,
      controller: 'ChangesRegisterDataDialogController',
      controllerAs: 'ctrl',
      template: ChangesRegisterDataTemplate,
      locals: {
        changes: formatedChanges
      },
      disableParentScroll: true,
      targetEvent: event
    });
  }
}

export const RegisterData = {
  bindings: {
    me: '<',
    registerData: '<'
  },
  template,
  controller: RegisterDataComponent
};
